module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v8-2-1.49d4ca47.jpg";